import { useDirectAccessAnalytics } from '../../hooks/useAnalytics';
import Footer from './Footer';

const DirectAccessFooter = () => {
  const { track } = useDirectAccessAnalytics();

  return <Footer track={track} isUserAuthenticated />;
};

export default DirectAccessFooter;
